export default {
  overview: {
    title: "Kunden Übersicht",
    archive_title: "Archivierte Kunden",
    subtitle: "Auflistung aller Kunden.",
    actions: {
      create_new: "Neuen Kunden erstellen",
    },
    search: {
      placeholder: "Suche",
    },
    table: {
      headers: {
        id: "ID",
        company: "Unternehmen",
        note: "Notizen",
        contact: "Ansprechpartner",
        projects: "Projekte",
        createdAt: "Erstellt am",
      },
      more_contacts: "+{count} weitere",
      projects: {
        total: "{n} Projekt | {n} Projekte",
        none: "Keine Projekte",
      },
      empty: {
        note: "Nicht gesetzt",
      },
    },
  },
  detail: {
    title: "Kunden Details",
    actions: {
      update: "Speichern",
      actions: "Aktionen",
      search_material: "Suche Materialien",
      search_machine: "Suche Maschinen",
      search_additional_effort: "Suche Zusätzliche Leistung",
    },
    tabs: {
      general: "Allgemein",
      additional_efforts: "Zusätzliche Leistungen",
      machines: "Maschinen",
      materials: "Materialien",
      contacts: "Kontakte",
      files: "Dateiablage",
      userPositions: "Personalrollen",
      configuration: "Konfiguration",
      activity: "Protokoll",
    },
    form: {
      company: "Unternehmen",
      note: "Notizen",
      // Die Adressfelder selbst stehen unter `general.address.*`.
      address_search_unavailable_hint: "Tragen Sie die Anschrift in die Felder unten ein.",
      default_currency: "Währung",
      configuration: {
        section: "Währung",
        field: "Standardwährung",
        currency_hint: "Gilt für alle Preise dieses Kunden.",
      },
      sections: {
        base_data: "Stammdaten",
        address: "Anschrift",
        note: "Notiz",
      },
      materials: {
        text: "Materialien",
        add_material: "Füge ein Material hinzu...",
        add_material_no_data: "Geben Sie den Namen eines Materials ein und klicken Sie auf dieses.",
        radio: {
          fixed_price: "Fixpreis",
          variable_price: "Variabler Preis",
        },
        selling_price: "Verkaufspreis",
        not_set: "Nicht gesetzt",
        surcharge: "Zuschlag",
        purchase_price: "Einkaufspreis",
        delete: "Löschen",
        multiplier: "Multiplikator",
        assign: "Material zuweisen",
        empty: "Noch keine Materialien zugewiesen.",
        filter: "Materialien filtern",
        empty_hint: "Leer lassen: der Preis wird im Projekt festgelegt",
        remove: "Material entfernen",
        restore: "Löschung rückgängig machen",
        packet_badge: "Paket",
        material_count: "{count} Materialien",
        // Die Einkaufspreise des Materials selbst: Ein Kunde hat keine eigenen, sie werden am Material gepflegt.
        purchase_prices: {
          record_default: "Standard des Materials",
          dangling:
            "Der bevorzugte Preis ist beim Material nicht mehr vorhanden. Projekte starten mit seinem Standard.",
          // Über der Liste hinter „Ändern“: womit die Projekte dieses Kunden starten.
          menu_title: "Für Projekte dieses Kunden",
          // Darunter, mit Lieferanten: die Preise hier sind die der Lieferanten vor ihrem Rabatt; ein Projekt bucht sie
          // abzüglich Rabatt.
          list_prices: "Listenpreise, ohne Lieferantenrabatt",
          // Ohne Lieferanten (vor der Einrichtung) die Zeile unter dem Verkaufspreis: „Einkaufspreis: Nacht · Ändern“.
          price: "Einkaufspreis",
          all: "Alle Preise",
          missing_in_currency: "Kein Preis in {currency}",
          count: "{count} Preis | {count} Preise",
          set: "Hinterlegen",
          set_title: "Einkaufspreis beim Material hinterlegen",
        },
        status: {
          created: "Neu",
          updated: "Geändert",
          deleted: "Entfernt",
        },
        assign_dialog: {
          title: "Materialien zuweisen",
          subtitle: "Ein oder mehrere Materialien aus dem Katalog wählen. Preise legst du danach je Zeile fest.",
          search_label: "Material suchen",
          no_results: "Kein Material gefunden",
          add: "Hinzufügen",
          cancel: "Abbrechen",
        },
      },
      machines: {
        text: "Maschinen",
        add_machine: "Füge eine Maschine hinzu...",
        add_machine_no_data: "Geben Sie den Namen einer Maschine ein und klicken Sie auf dieses.",
        radio: {
          fixed_price: "Fixpreis",
          variable_price: "Variabler Preis",
        },
        selling_price: "Verkaufspreis",
        not_set: "Nicht gesetzt",
        surcharge: "Zuschlag",
        purchase_price: "Einkaufspreis",
        delete: "Löschen",
        multiplier: "Multiplikator",
        assign: "Maschine zuweisen",
        empty: "Noch keine Maschinen zugewiesen.",
        filter: "Maschinen filtern",
        selling_preview: "ergibt Verkaufspreis",
        empty_hint: "Leer lassen: der Preis wird im Projekt festgelegt",
        remove: "Maschine entfernen",
        restore: "Löschung rückgängig machen",
        packet_badge: "Paket",
        machine_count: "{count} Maschinen",
        // Die Einkaufspreise der Maschine selbst: Ein Kunde hat keine eigenen, sie werden an der Maschine gepflegt.
        purchase_prices: {
          record_default: "Standard der Maschine",
          dangling:
            "Der bevorzugte Preis ist bei der Maschine nicht mehr vorhanden. Projekte starten mit ihrem Standard.",
          // Über der Liste hinter „Ändern“: womit die Projekte dieses Kunden starten.
          menu_title: "Für Projekte dieses Kunden",
          // Darunter, mit Lieferanten: die Preise hier sind die der Lieferanten vor ihrem Rabatt; ein Projekt bucht sie
          // abzüglich Rabatt.
          list_prices: "Listenpreise, ohne Lieferantenrabatt",
          // Ohne Lieferanten (vor der Einrichtung) die Zeile unter dem Verkaufspreis: „Einkaufspreis: Nacht · Ändern“.
          price: "Einkaufspreis",
          all: "Alle Preise",
          missing_in_currency: "Kein Preis in {currency}",
          count: "{count} Preis | {count} Preise",
          set: "Hinterlegen",
          set_title: "Einkaufspreis bei der Maschine hinterlegen",
        },
        status: {
          created: "Neu",
          updated: "Geändert",
          deleted: "Entfernt",
        },
        assign_dialog: {
          title: "Maschinen zuweisen",
          subtitle: "Eine oder mehrere Maschinen aus dem Katalog wählen. Preise legst du danach je Zeile fest.",
          search_label: "Maschine suchen",
          no_results: "Keine Maschine gefunden",
          packet_info:
            "Dieses Paket fügt {count} Maschinen hinzu. Sie werden ohne Preis übernommen und können danach einzeln bepreist werden.",
          add: "Hinzufügen",
          cancel: "Abbrechen",
        },
      },
      additional_efforts: {
        text: "Zusätzliche Aufwände",
        add_additional_effort: "Füge eine Zusätzliche Leistung hinzu...",
        add_additional_effort_no_data: "Geben Sie den Namen einer Zusätzlichen Leistung ein und klicken Sie auf diese.",
        radio: {
          fixed_price: "Fixpreis",
          variable_price: "Variabler Preis",
        },
        selling_price: "Verkaufspreis",
        not_set: "Nicht gesetzt",
        surcharge: "Zuschlag",
        purchase_price: "Einkaufspreis",
        delete: "Löschen",
        multiplier: "Multiplikator",
        assign: "Leistung zuweisen",
        empty: "Noch keine Leistungen zugewiesen.",
        filter: "Leistungen filtern",
        empty_hint: "Leer lassen: der Preis wird im Projekt festgelegt",
        remove: "Leistung entfernen",
        restore: "Löschung rückgängig machen",
        packet_badge: "Paket",
        effort_count: "{count} Leistungen",
        status: {
          created: "Neu",
          updated: "Geändert",
          deleted: "Entfernt",
        },
        assign_dialog: {
          title: "Leistungen zuweisen",
          subtitle: "Eine oder mehrere Leistungen aus dem Katalog wählen. Preise legst du danach je Zeile fest.",
          search_label: "Leistung suchen",
          no_results: "Keine Leistung gefunden",
          add: "Hinzufügen",
          cancel: "Abbrechen",
        },
      },
      contacts: {
        text: "Ansprechpartner",
        add_contact: "Neuen Ansprechpartner hinzufügen",
        add: "Hinzufügen",
        add_title: "Neuen Kontakt hinzufügen",
        add_subtitle: "Ansprechpartner für den Kunden",
        edit_title: "Kontakt bearbeiten",
        edit_subtitle: "Ansprechpartner für den Kunden",
        all_contacts: "Ansprechpartner",
        empty: "Noch keine Ansprechpartner hinterlegt.",
        table: {
          contact: "Ansprechpartner",
          phone: "Telefon",
        },
        delete: {
          title: "Ansprechpartner löschen",
          text: "Soll dieser Ansprechpartner wirklich gelöscht werden?",
          agree: "Löschen",
          disagree: "Abbrechen",
        },
        sections: {
          person: "Person",
          contact: "Kontakt",
        },
        position: "Position",
        email: "E-Mail",
        lastName: "Nachname",
        firstName: "Vorname",
        telephoneNumber: "Telefonnummer",
        mobileTelephoneNumber: "Mobiltelefonnummer",
        gender: {
          salutation: "Anrede",
          mr: "Herr",
          ms: "Frau",
          generic: "Keine Angabe",
        },
      },
      userposition: {
        text: "Personalrollen",
        add_userposition: "Personalrolle hinzufügen",
        noData: "Keine Personalrollen vorhanden",
        delete: "Löschen",
        hourlyRate: "Stundensatz",
        assign: "Personalrolle zuweisen",
        filter: "Personalrollen filtern",
        empty: "Noch keine Personalrollen zugewiesen.",
        not_set: "Nicht gesetzt",
        remove: "Personalrolle entfernen",
        assign_dialog: {
          title: "Personalrollen zuweisen",
          subtitle: "Eine oder mehrere Personalrollen auswählen. Stundensatz danach je Zeile anpassen.",
          search_label: "Personalrolle suchen",
          no_results: "Keine Personalrolle gefunden",
          add: "Hinzufügen",
          cancel: "Abbrechen",
        },
      },
    },
  },
  create: {
    title: "Kunden Anlegen",
    subtitle: "Neuen Kunden anlegen.",
  },
  contact: {
    position: {
      no_results: 'Keine Ergebnisse gefunden zu "<strong>{value}</strong>"',
      manage: "Verwalten",
      overview: {
        title: "Alle Ansprechpartner Positionen",
        subtitle: "Alle Ansprechpartner Positionen sind hier aufgelistet",
        empty_items: "Keine Positionen vorhanden",
        add_item: "Fügen Sie eine neue Position hinzu",
      },
    },
  },
}
